import { useState, useEffect } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    const trackAndGetCount = async () => {
      try {
        // Track this visit
        const trackRes = await axios.post(`${API}/visitors/track`);
        setVisitorCount(trackRes.data.total_visitors || 0);
      } catch (error) {
        // Fallback to just getting count
        try {
          const countRes = await axios.get(`${API}/visitors/count`);
          setVisitorCount(countRes.data.total_visitors || 0);
        } catch (e) {
          console.error("Error getting visitor count:", e);
        }
      }
    };

    trackAndGetCount();
  }, []);

  if (visitorCount === 0) return null;

  return (
    <div className="fixed bottom-4 left-4 z-40 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-full px-4 py-2 shadow-lg flex items-center gap-2">
      <Users className="w-4 h-4 text-[#007AFF]" />
      <span className="text-sm font-semibold text-gray-700">
        {visitorCount.toLocaleString()} visitors
      </span>
    </div>
  );
};

export default VisitorCounter;
